import {
  BarsLineIcon,
  BriefcaseLineIcon,
  CalendarLineIcon,
  ChatLineIcon,
  CheckSquareLineIcon,
  FlagLineIcon,
  GlobeLineIcon,
  SearchLineIcon,
  TrendLineIcon,
} from '@/shared/ui/icons';

export const RESOURCE_DOCUMENT_STATUSES = {
  PUBLISHED: 'published',
  SOON: 'soon',
};

export const RESOURCE_SAMPLE_VARIANTS = {
  DIALOG: 'dialog',
  TEMPLATE: 'template',
  COMPARE: 'compare',
};

export const RESOURCE_DOCUMENTS = [
  {
    id: 'site',
    slug: 'sait-strakhovoho-ahenta',
    status: RESOURCE_DOCUMENT_STATUSES.PUBLISHED,
    icon: GlobeLineIcon,
    sampleVariant: RESOURCE_SAMPLE_VARIANTS.TEMPLATE,
  },
  {
    id: 'seo',
    slug: 'seo-dlia-strakhovoho-ahenta',
    status: RESOURCE_DOCUMENT_STATUSES.PUBLISHED,
    icon: SearchLineIcon,
    sampleVariant: RESOURCE_SAMPLE_VARIANTS.COMPARE,
  },
  {
    id: 'sell',
    slug: 'yak-prodavaty-strakhuvannia',
    status: RESOURCE_DOCUMENT_STATUSES.PUBLISHED,
    icon: ChatLineIcon,
    sampleVariant: RESOURCE_SAMPLE_VARIANTS.DIALOG,
  },
  {
    id: 'prolong',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: CalendarLineIcon,
  },
  {
    id: 'start',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: FlagLineIcon,
  },
  {
    id: 'partners',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: BriefcaseLineIcon,
  },
  {
    id: 'scripts',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: CheckSquareLineIcon,
  },
  {
    id: 'season',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: TrendLineIcon,
  },
  {
    id: 'compare',
    status: RESOURCE_DOCUMENT_STATUSES.SOON,
    icon: BarsLineIcon,
  },
];
